import { useHandlers } from '../../../context/page-context';
import type { APISettingsApiContract } from '../api';

export function useAPISettingsApi(): { APISettingsApi: APISettingsApiContract } {
  const { apis } = useHandlers();
  return { APISettingsApi: apis.APISettings };
}
